// Pay-link endpoints (kbt-backend publicInvoices/). No login: the token from
// the /pay/:token URL is sent in the POST body so it never lands in server
// request logs.
import Api from '../utils/axios';

export const lookupPayInvoice = (token) => Api.post('/public/invoices/lookup', { token });

export const createPayInvoiceIntent = (token) => Api.post('/public/invoices/pay-intent', { token });

export const createPayInvoicePlan = (token, { installments, startDate }) =>
  Api.post('/public/invoices/plan-setup', { token, installments, startDate });
